import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentInHandoff } from '@/pages/workspaces/journeys/integrations/segment-in/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/**
 * The legacy `/journeys/integrations/segment_in` URL — what the integrations directory links to.
 * Flag off it renders the embedded Ember host; flag on it forwards to the migrated URL.
 */
function JourneysSegmentInRoute() {
  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSegmentInHandoff />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/segment_in')({
  component: JourneysSegmentInRoute,
});
